// Axios
import Axios from "./axios"

export const verifyResetPassword = (email, values) => {
    return new Promise((resolve, reject) => {
        const data = Axios.put(`/user/verifyResetPassword/${email}`, values)
        setTimeout(() => resolve(data), 0)
    })
}